import { observer } from "mobx-react-lite";
import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import { ChildEntitiesStore } from "../../ChildEntitiesStore";
import { ChildEntsButton } from "../ChildEntsButton";

interface PropsChildEntsCreate {
  store: ChildEntitiesStore;
  disabled?: boolean;
}

export const ChildEntsCreate: React.FC<PropsChildEntsCreate> = observer(
  ({ store, store: { currObjName, isDropdownView }, disabled }) => (
    <ChildEntsButton
      icon={<PlusOutlined />}
      disabled={disabled}
      onClick={() => store.openCreation()}
      isDropdownView={isDropdownView}
    >
      {currObjName}
    </ChildEntsButton>
  ),
);
